import { render, staticRenderFns } from "./ReceiptPreview.vue?vue&type=template&id=0fe8fd1e"
import script from "./ReceiptPreview.vue?vue&type=script&lang=js"
export * from "./ReceiptPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports